import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import { assets } from "../assets/assets";
import './conserto_relogio.css'; // Reutilizando o CSS para manter o padrão visual
import { abrirOrcamentoWhats, trazerRodapePaginasServicos, trazerTituloServicos } from '../utils/utils';

const ServicosAfiacao = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Trinco | Serviços de afiação";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />

      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.servicosAfiacao})` }}>
        <div className="servico-hero-overlay">
          <h1>Serviços de Afiação</h1>
          <p>Precisão em cada corte</p>
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloServicos('afiações')}</h2>
        </article>

        {/* Bloco 1: Afiação de Tesouras */}
        <section className="sessao-explicativa">
          <div className="texto-lado">
            <h3>Tesouras</h3>

            <h4>Afiação de lâminas</h4>
            <p>Restauração do fio para cortes limpos.</p>

            <h4>Ajustes de lâminas</h4>
            <p>Correção do fechamento das lâminas para funcionamento uniforme.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.afiacaoTesouras} alt="Profissional afiando tesouras" />
          </div>
        </section>

        {/* Bloco 2: Afiação de Alicates */}
        <section className="sessao-explicativa reverse">
          <div className="texto-lado">
            <h3>Alicates</h3>

            <h4>Afiação de lâminas</h4>
            <p>Recuperação do fio para cortes firmes.</p>

            <h4>Ajuste de lâminas</h4>
            <p>Alinhamento para fechamento correto.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.afiacaoAlicates} alt="Afiação profissional de alicates" />
          </div>
        </section>

        {/* Bloco 3: Afiação de Facas */}
        <section className="sessao-explicativa">
          <div className="texto-lado">
            <h3>Facas</h3>

            <h4>Afiação de lâmina</h4>
            <p>Restauração do corte para melhor desempenho.</p>

            <h4>Polimento do fio</h4>
            <p>Acabamento para um deslizamento mais suave.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.afiacaoFacas} alt="Faca sendo afiada" />
          </div>
        </section>

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasServicos('serviços de afiação')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('afiações')}>
            Solicitar orçamento
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default ServicosAfiacao;